import GET_COUNTRY from '@/graphql/Country/getCountry.gql';
import { graphClient } from '../main';

export default class CountryResource {
    async get () {
        return await graphClient.query({
            query: GET_COUNTRY,
            update: data => data.countries
        })
    }
}